<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import axios from 'axios'

const router = useRouter()
const email = ref('')
const password = ref('')
const error = ref('')

async function login() {
  error.value = ''

  try {
    const formData = new URLSearchParams()
    formData.append('login', email.value)
    formData.append('password', password.value)

    const response = await axios.post('utilisateur/login', formData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    })

    const tokenRecu = response.data

    console.log('Login valide, token reçu :', tokenRecu)

    localStorage.setItem('isAuthenticated', 'true')
    localStorage.setItem('token', tokenRecu)

    await router.push({
      name: 'rechargementDepositaire',
    })
  } catch (err) {
    if (err.response) {
      if (err.response.status === 401) {
        error.value = 'Erreur : Utilisateur ou Mot de passe INCONNU'
      } else if (err.response.status === 403) {
        error.value = 'Erreur : Accès expiré'
      } else {
        error.value = 'Erreur : Veuillez réessayer plus tard.'
      }
    } else {
      error.value = 'Erreur inconnue'
    }
    console.error('Erreur de connexion:', err)
  }
}
</script>

<template>
  <div class="login-container container mt-5">
    <div class="row justify-content-center">
      <div class="col-md-6">
        <div class="card shadow">
          <div class="card-body">
            <h2 class="card-title text-center mb-4">Connexion</h2>

            <form @submit.prevent="login">
              <div
                v-if="error"
                id="login-error"
                class="alert alert-danger"
                role="alert"
              >
                {{ error }}
              </div>

              <div class="mb-3">
                <label for="email" class="form-label">Login</label>
                <input
                  v-model="email"
                  type="email"
                  class="form-control"
                  id="email"
                  autocomplete="email"
                  :aria-invalid="error ? 'true' : 'false'"
                  :aria-describedby="error ? 'login-error' : null"
                  required
                />
              </div>

              <div class="mb-3">
                <label for="password" class="form-label">Mot de passe</label>
                <input
                  v-model="password"
                  type="password"
                  class="form-control"
                  id="password"
                  autocomplete="current-password"
                  :aria-invalid="error ? 'true' : 'false'"
                  :aria-describedby="error ? 'login-error' : null"
                  required
                />
              </div>

              <div class="d-grid gap-2 mt-4">
                <button
                  type="submit"
                  class="btn btn-primary"
                >
                  Se connecter</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '@/assets/main';

.login-container {
  padding: 2rem;
}

button {
  background-color: var(--color-bleu-luneo);
  border-color: var(--color-bleu-2);
}
</style>
